var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewEndorsement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M1.882 14.616c.27 0 .528-.116.706-.32.057-.056 5.252-5.91 12.744-6.23 4.847-.207 9.59 1.882 14.117 6.287a.941.941 0 1 0 1.3-1.355c-4.904-4.753-10.137-7.05-15.493-6.814-8.3.357-13.854 6.588-14.117 6.87a.941.941 0 0 0 .743 1.562zm27.53 3.088c-.057.065-5.252 5.91-12.744 6.23-4.866.217-9.59-1.882-14.117-6.287a.945.945 0 1 0-1.318 1.355c4.706 4.537 9.666 6.833 14.776 6.833h.735c8.3-.357 13.854-6.588 14.117-6.87a.941.941 0 0 0-1.412-1.243l-.037-.018zM16 11.652a4.292 4.292 0 0 1 2.41.724.941.941 0 0 0 1.035-1.571A6.23 6.23 0 1 0 22.268 16a6.306 6.306 0 0 0-.452-2.325.944.944 0 1 0-1.75.706c.2.516.3 1.066.292 1.619A4.358 4.358 0 1 1 16 11.652z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#636176",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewEndorsement);
export default __webpack_public_path__ + "static/media/view-endorsement.de1a1c907c9acb120a0fd8db4ab1e7a5.svg";
export { ForwardRef as ReactComponent };